import { useEffect, useRef, useState } from 'react'
import { Link, useParams } from "react-router-dom";

import {
   NonProfitDonationsSection,
   Title,
   DonationsReceived,
   ReceivedText,
   DownloadReportBtn,
   NonProfitDonationsText,
} from "./nonprofitDonationsStyle";

import CommonTable from '../../common/commonTable';
import { MESSAGE } from '../../../utils/message';
import { Button } from 'react-bootstrap';
import FilterDropdown from '../filterDropdown/filterDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { nonprofitDonationHandler } from '../../../redux/slices/myNonprofit/nonprofitDonation-slice';
import { DropdownOptions, TableColumnsProps } from '../../../utils/types';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import SimpleLoader from '../simpleLoader/Loader';
import * as XLSX from "xlsx";


const NonProfitDonations = () => {
   const { id } = useParams()
   const [selectedFilter, setSelectedFilter] = useState<number | string>(6);
   const dispatch: any = useDispatch();
   const tableRef = useRef(null);
   const donationListData = useSelector((state: any) => state?.nonprofitDonation?.data?.results)



   const [loader, setLoader] = useState(true);
   useEffect(() => {
      if (id && selectedFilter) {
         setLoader(true);
         dispatch(nonprofitDonationHandler(id, { type: selectedFilter as number }))
            .then(() => setLoader(false))
            .catch(() => setLoader(false));
      }
   }, [selectedFilter])

   useEffect(() => {
      if (id) {
         setLoader(true);
         dispatch(nonprofitDonationHandler(id))
            .then(() => setLoader(false))
            .catch(() => setLoader(false));
      }
   }, [])

   const columns: TableColumnsProps[] = [
      {
         id: 'tnx_id',
         header: 'Transaction ID'
      },
      {
         id: 'date',
         header: "Date",
         render: (data: any) => {
             if (!data) return '-';
            const date = new Date(data);
            const mm = String(date.getMonth() + 1).padStart(2, '0');
            const dd = String(date.getDate()).padStart(2, '0');
            const yyyy = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            return `${mm}/${dd}/${yyyy} ${hours}:${minutes}`;
         }
      },
      {
         id: 'donar_name',
         header: "Donor Name",
           render: (data: any) => data || '-'
      },
      {
         id: 'email',
         header: "Email",
          render: (data: any) => data || '-'
      },
      {
         id: 'memorial_name',
         header: "Designation or Memorial Name",
           render: (data: any) => data || '-'
      },
      {
         id: 'amount',
         header: "Dollar Amount",
       render: (data: any, row: any) => {
      const currency = row.currency || 'USD';
      return data != null
         ? new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(data)
         : '-';
   }
      },
      {
         id: 'processed_by',
         header: "Processed by",
           render: (data: any) => data || '-'
      },
      {
         id: 'transection_fees',
         header: "Transaction fees",
         render: (data: any) => data ? `$${data}` : ''
      },
      {
         id: 'status',
         header: "Payment Status",
            render: (data: any) => data || '-'

      }
   ]

   const options: DropdownOptions[] = [
      { label: "All", value: 6 },
      { label: "This Month", value: 1 },
      { label: "This Quarter", value: 2 },
      { label: "This Year", value: 3 },
      { label: "Last Month", value: 4 },
      { label: "Last Year", value: 5 },
   ]
   const downloadExcel = () => {
   const customHeaders = [
      'Transaction ID',
      'Date',
      'Donor Name',
      'Email',
      'Designation or Memorial Name',
      'Dollar Amount',
      'Processed By',
      'Transaction Fees',
      'Payment Status'
   ];

   const formattedData = donationListData.map((item: any) => {
      const currency = item.currency || 'USD';

      const formatCurrency = (value: number | null) =>
         value != null
            ? new Intl.NumberFormat('en-US', { style: 'currency', currency }).format(value)
            : '-';

      const formatDate = (dateStr: string) => {
         if (!dateStr) return '-';
         const date = new Date(dateStr);
         const mm = String(date.getMonth() + 1).padStart(2, '0');
         const dd = String(date.getDate()).padStart(2, '0');
         const yyyy = date.getFullYear();
         const hours = String(date.getHours()).padStart(2, '0');
         const minutes = String(date.getMinutes()).padStart(2, '0');
         return `${mm}/${dd}/${yyyy} ${hours}:${minutes}`;
      };

      return [
         item.tnx_id || '-',
         formatDate(item.date),
         item.donar_name || '-',
         item.email || '-',
         item.memorial_name || '-',
         formatCurrency(item.amount),
         item.processed_by || '-',
         formatCurrency(item.transection_fees),
         item.status || '-'
      ];
   });

   const worksheet = XLSX.utils.aoa_to_sheet([customHeaders, ...formattedData]);
   const workbook = XLSX.utils.book_new();
   XLSX.utils.book_append_sheet(workbook, worksheet, "Donations");
   XLSX.writeFile(workbook, "Donations_Received.xlsx");
};


   // const downloadExcel = () => {

   //    const customHeaders = [
   //       'Transaction ID',
   //       'Date',
   //       'Donor Name',
   //       'Email',
   //       'Designation or Memorial_name',
   //       'Dollar Amount',
   //       'Processed By',
   //       'Transaction Fees',
   //       'Payment Status'
   //    ];

   //    const formattedData = donationListData.map((item: any) => ({
         
   //       transaction_id: item.tnx_id,  // Renaming 'tnx_id' to 'transaction_id'
   //       date: item.date,
   //       donor_name: item.donar_name,
   //       email: item.email,
   //       designation_name: item['Designation or Memorial_name'],
   //       amount: item.amount,
   //       processed_by: item.processed_by,
   //       transaction_fees: item.transaction_fees,
   //       status: item.status
   //    }));

   //    // Create worksheet with custom headers
   //    const worksheet = XLSX.utils.aoa_to_sheet([customHeaders, ...formattedData.map((item: any) => [
   //       item.transaction_id,
   //       item.date,
   //       item.donor_name,
   //       item.email,
   //       item.designation_name,
   //       item.amount,
   //       item.processed_by,
   //       item.transaction_fees,
   //       item.status
   //    ])]);

   //    const workbook = XLSX.utils.book_new();
   //    XLSX.utils.book_append_sheet(workbook, worksheet, "Donations");
   //    XLSX.writeFile(workbook, "Donations_Received.xlsx");
   // };

   return (
      <NonProfitDonationsSection>
         <Title>{MESSAGE.donationsReceived}</Title>
         <DonationsReceived>
            <ReceivedText>{donationListData?.length || 0} donations received in</ReceivedText>
            <FilterDropdown options={options} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
            {/* <DownloadTableExcel
                    filename="Donations Received"
                    sheet="Donations"
                    currentTableRef={tableRef.current}

                > */}
            <DownloadReportBtn><Button className='report-btn' onClick={downloadExcel}>{MESSAGE.downloadReport}</Button></DownloadReportBtn>
            {/* </DownloadTableExcel> */}

         </DonationsReceived>
         {loader ? (
            <div style={{ position: 'relative', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
               <SimpleLoader />
            </div>
         ) : (
            <CommonTable columns={columns} data={donationListData} handleRowClick={() => { }} tableRef={tableRef} />
         )}
         <NonProfitDonationsText>
            {MESSAGE.donationDescription}
         </NonProfitDonationsText>
         <NonProfitDonationsText>Data on this section is for Donations received after November 1st 2016.</NonProfitDonationsText>
         <NonProfitDonationsText> See the <Link to="/support/home"> FAQs.</Link></NonProfitDonationsText>

      </NonProfitDonationsSection>
   )
}

export default NonProfitDonations